import Header from '../../../Shared-Component/Header/Header'
import Footer from '../../../Shared-Component/Footer/Footer'
import CampusSlashTitle from '../../CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle'
import CampusDynamicSection from '../../CampusSharedComponent/CampusSections/CampusDynamicSection/CampusDynamicSection'
import transportation from "../../../assets/CampuLifeImages/transportation.jpg"


const Transportation = () => {
    const libraryData = {
    img: transportation,
    content: "Noorul Islam College of Arts & Science provides reliable and convenient transportation facilities to ensure safe and timely travel for students, faculty, and staff. The institute operates a fleet of buses and vehicles covering key routes across the city and nearby areas, facilitating easy commuting to and from the campus. The transport services are well-coordinated and punctual, with designated pick-up and drop-off points. Special arrangements are made during academic events, field visits, and training programs to support smooth logistical operations. The transportation facility reflects Noorul Islam College of Arts & Science commitment to accessibility, safety, and comfort for all its stakeholders."
  }
      
  return (
    <>
     <div>
        <Header />
        <div className='campusmaincontainer'>
        <div className='campus-container'>
       <CampusSlashTitle slashTitle="Transportation" />
      <CampusDynamicSection data={libraryData} />
      </div>
      <Footer />
      </div>
      </div>
    </>
  )
}

export default Transportation